import React, { Fragment } from 'react';
import { Table, Button, Menu, Divider, Dropdown, Icon, Modal } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formatPrice, formatTimestamp } from 'utils/utils.js';
import styles from './Table.less';

@connect(({ standardCRUD, loading }) => ({
  loading:
    loading.effects['standardCRUD/fetchDataSource'] || loading.effects['standardCRUD/delete'],
  dataSource: standardCRUD.dataSource,
  pagination: standardCRUD.pagination,
}))
export default class Record extends React.Component {
  handleAdd = () => {
    this.props.dispatch(routerRedux.push(`/demo/standardCRUD/detail?type=add`));
  };

  handleQuery = rowData => {
    this.props.dispatch(routerRedux.push(`/demo/standardCRUD/detail?type=query&id=${rowData.id}`));
  };

  handleEdit = rowData => {
    this.props.dispatch(routerRedux.push(`/demo/standardCRUD/detail?type=edit&id=${rowData.id}`));
  };

  handleDelete = rowData => {
    const { dispatch } = this.props;

    Modal.confirm({
      content: '是否删除？',
      onOk: () => {
        dispatch({
          type: 'standardCRUD/delete',
          id: rowData.id,
        }).then(() => {
          dispatch({ type: 'standardCRUD/toggleRefreshFlag' });
        });
      },
    });
  };

  handleTableChange(pagination, filters, sorter) {
    this.props.dispatch({
      type: 'standardCRUD/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination, filters, sorter);
    }
  }

  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
      },
      {
        title: '姓名',
        dataIndex: 'name',
      },
      {
        title: '年龄',
        dataIndex: 'age',
      },
      {
        title: '性别',
        dataIndex: 'sex',
        render: val => (val === 0 ? '女' : '男'),
      },
      {
        title: '生日',
        dataIndex: 'birthday',
        render: val => formatTimestamp(val),
      },
      {
        title: '财富（元）',
        dataIndex: 'riches',
        render: val => formatPrice(val),
      },
      {
        title: '操作',
        render: rowData => {
          const menu = (
            <Menu>
              <Menu.Item onClick={this.handleEdit.bind(this, rowData)}>编辑</Menu.Item>
              <Menu.Item onClick={this.handleDelete.bind(this, rowData)}>删除</Menu.Item>
            </Menu>
          );

          return (
            <Fragment>
              <a onClick={this.handleQuery.bind(this, rowData)}>查看</a>
              <Divider type="vertical" />
              <Dropdown overlay={menu}>
                <a>
                  更多<Icon type="down" />
                </a>
              </Dropdown>
            </Fragment>
          );
        },
      },
    ];

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <div className="table-operation-buttons-wraps">
          <Button type="primary" icon="plus" onClick={this.handleAdd.bind(this)}>
            新增
          </Button>
        </div>
        <Table
          loading={this.props.loading}
          rowKey="id"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={pagination}
          onChange={this.handleTableChange.bind(this)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Demo/StandardCRUD/Table.js